<div class="playlist-tag-label">
  <svg *ngIf="!noHash" width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.125 8.5L2.6625 6.375H0.75L0.9375 5.625H2.85L3.4125 3.375H1.25L1.4375 2.625H3.6L4.125 0.5H4.8625L4.3375 2.625H6.6L7.125 0.5H7.8625L7.3375 2.625H9.25L9.0625 3.375H7.15L6.5875 5.625H8.75L8.5625 6.375H6.4L5.875 8.5H5.125L5.6625 6.375H3.4L2.875 8.5H2.125ZM3.5875 5.625H5.85L6.4125 3.375H4.15L3.5875 5.625Z"
      fill="#C30E21"
    />
  </svg>
  <ng-content></ng-content>
</div>
